module.exports = __webpack_public_path__ + "static/media/plant-circular.990af6cc.png";